import { Button, styled } from '@mui/material';

import { visuallyHidden } from '../../../../styles/mui/common';

export const ButtonAction = styled(Button)`
  border-radius: var(--border-radius-huge);
  min-width: 0;
  padding: var(--spacing-tiny);

  &:hover {
    background-color: var(--color-grey-pale);
  }
`;

export const HiddenLink = styled('a')`
  ${visuallyHidden}
`;
